module.exports = __webpack_public_path__ + "img/straight-rail-vertical-stone-path-background-remnants.3ae77088.png";